const CIA_THEME_KEY = 'cia-theme-mode';
const CIA_THEME_QUERY = window.matchMedia('(prefers-color-scheme: dark)');

function getSavedTheme() {
  try {
    const value = window.localStorage.getItem(CIA_THEME_KEY);
    return value === 'day' || value === 'night' ? value : null;
  } catch (error) { return null; }
}

function setSavedTheme(theme) {
  try { window.localStorage.setItem(CIA_THEME_KEY, theme); } catch (error) {}
}

function updateThemeControls(theme) {
  const isNight = theme === 'night';
  document.querySelectorAll('[data-cia-theme-toggle]').forEach((toggle) => {
    const action = isNight ? 'Switch to day mode' : 'Switch to night mode';
    toggle.setAttribute('aria-label', action);
    toggle.setAttribute('title', action);
    toggle.setAttribute('aria-pressed', String(isNight));
    const label = toggle.querySelector('[data-cia-theme-label]');
    if (label) label.textContent = isNight ? 'Night mode active' : 'Day mode active';
  });
}

function applyTheme(theme, persist = false) {
  document.documentElement.dataset.ciaTheme = theme;
  document.documentElement.style.colorScheme = theme === 'night' ? 'dark' : 'light';
  updateThemeControls(theme);
  if (persist) setSavedTheme(theme);
  document.dispatchEvent(new CustomEvent('cia:theme-change', { detail: { theme } }));
}

function initialiseThemeControls(root = document) {
  root.querySelectorAll('[data-cia-theme-toggle]').forEach((toggle) => {
    if (toggle.dataset.ciaThemeReady === 'true') return;
    toggle.dataset.ciaThemeReady = 'true';
    toggle.addEventListener('click', () => {
      const nextTheme = document.documentElement.dataset.ciaTheme === 'night' ? 'day' : 'night';
      applyTheme(nextTheme, true);
    });
  });
  updateThemeControls(document.documentElement.dataset.ciaTheme || 'day');
}

initialiseThemeControls();
document.addEventListener('shopify:section:load', (event) => initialiseThemeControls(event.target));
CIA_THEME_QUERY.addEventListener?.('change', (event) => {
  if (!getSavedTheme()) applyTheme(event.matches ? 'night' : 'day');
});

const CIA_CART_ICON = `
<svg aria-hidden="true" width="21" height="21" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.5 8.5H17.5L18.25 20H5.75L6.5 8.5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
  <path d="M9 9V6.75C9 5.23 10.23 4 11.75 4H12.25C13.77 4 15 5.23 15 6.75V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

function ensureCiaHomepageCartIcon(root = document) {
  const scope = root.matches?.('[id^="cia-homepage-"]')
    ? root
    : root.querySelector?.('[id^="cia-homepage-"]') || document.querySelector('[id^="cia-homepage-"]');
  if (!scope) return;

  const utilityNav = scope.querySelector('.cia-nav--right');
  if (!utilityNav) return;

  let cartLink = Array.from(utilityNav.querySelectorAll('a')).find((link) => {
    try { return new URL(link.href, window.location.origin).pathname === '/cart'; }
    catch (error) { return false; }
  });

  if (!cartLink) {
    cartLink = document.createElement('a');
    cartLink.href = '/cart';
    utilityNav.appendChild(cartLink);
  }

  const countMatch = (cartLink.textContent || '').match(/\((\d+)\)/);
  const count = countMatch ? countMatch[1] : '0';

  cartLink.className = 'cia-homepage-cart-icon';
  cartLink.setAttribute('aria-label', `Cart (${count})`);
  cartLink.setAttribute('title', 'Cart');
  cartLink.innerHTML = `${CIA_CART_ICON}<span class="visually-hidden">Cart (${count})</span>`;
  cartLink.style.display = 'inline-flex';
  cartLink.style.alignItems = 'center';
  cartLink.style.justifyContent = 'center';
  cartLink.style.width = '24px';
  cartLink.style.height = '24px';
  cartLink.style.flex = '0 0 24px';
  cartLink.style.color = 'currentColor';
  cartLink.style.opacity = '0.92';
  cartLink.style.lineHeight = '1';
  cartLink.querySelector('svg').style.display = 'block';
  cartLink.querySelector('svg').style.width = '21px';
  cartLink.querySelector('svg').style.height = '21px';
  utilityNav.appendChild(cartLink);
}

function refreshCiaHeader(root = document) {
  ensureCiaHomepageCartIcon(root);
  window.setTimeout(() => ensureCiaHomepageCartIcon(root), 150);
  window.setTimeout(() => ensureCiaHomepageCartIcon(root), 600);
}

refreshCiaHeader();
document.addEventListener('DOMContentLoaded', () => refreshCiaHeader());
document.addEventListener('shopify:section:load', (event) => refreshCiaHeader(event.target));

function applyCiaApprovedHeroCopy(root = document) {
  const hero = root.querySelector?.('[id^="cia-homepage-"] .cia-hero__content') || document.querySelector('[id^="cia-homepage-"] .cia-hero__content');
  if (!hero) return;
  const kicker = hero.querySelector('.cia-kicker');
  if (kicker) kicker.textContent = 'THE MAYFAIR CODE — W1';
  const heading = hero.querySelector('h1');
  if (heading) heading.innerHTML = 'IN ACTION.<br>BY DESIGN.';
  const body = Array.from(hero.children).find((element) => element.tagName === 'P' && !element.classList.contains('cia-kicker'));
  if (body) body.innerHTML = 'The opening chapter of C|I|A.<br>Designed in London. Built for movement.';
  const button = hero.querySelector('.cia-button');
  if (button) button.textContent = 'SHOP THE MAYFAIR CODE';
}

applyCiaApprovedHeroCopy();
document.addEventListener('DOMContentLoaded', () => applyCiaApprovedHeroCopy());
document.addEventListener('shopify:section:load', (event) => applyCiaApprovedHeroCopy(event.target));
